import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleEdit } from './ScheduleMenuActions';
import { AppState } from '../../app/state/AppState';
import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { userCanEditSchedule, containsAccelerationSchedule } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';

export const ScheduleEditAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EditSchedule,
  translateName: Messages.editScheduleSettings_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEdit(targetItems)
};
